// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GHwRN","newExpiryDate":"styles_newExpiryDate__3RzZ9","footer":"styles_footer__34W8B"};